<template>
    <base-side-bar>
        <div
            ref="container"
            class="flex flex-col items-center justify-center w-full mx-10"
        >
            <h2
                class="mb-4 font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
            >
                Profils des investisseurs
            </h2>
         <!--   <wide-card>
                <base-tips-alert>
                    <p class="my-0 text-gray-700">
                        Il faut se lancer dans un projet dont les
                        caractéristiques (fonctionnement, perspectives, etc...)
                        reportent parfaitement à vos motivations et à vos
                        objectifs.
                    </p>
                </base-tips-alert>
            </wide-card> -->
            <transition-group
                class="w-full"
                enter-active-class="transition duration-100 ease-out"
                enter-class="scale-95 opacity-0"
                enter-to-class="scale-100 opacity-100"
                leave-active-class="transition duration-100 ease-in transform duration-75ease-in"
                leave-class="scale-100 opacity-100"
                leave-to-class="scale-95 opacity-0"
            >
                <!-- fruit-list fruit-list-item -->
                <!-- class="bpi-card" -->
                <component
                    ref="investors"
                    v-for="(investor, index) in investors"
                    :key="investor.key"
                    :is="investor.model"
                    :data="investor.object"
                    v-on:remove="removeInvestor($event, index)"
                />
            </transition-group>
            <base-add-button
                title="Ajouter un autre investisseur"
                @click="addInvestor"
            />
            <base-primary-button title="Suivant" @click="nextStep" />
        </div>
    </base-side-bar>
</template>

<script>
import Investor from "./ProfilsDesInvestisseurs/investor";
import WideCard from "@/components/cards/wideCard";
import { scrollToError } from "@/mixins/scrollToMixin.js";

import { mapState } from "vuex";
export default {
    components: {
        Investor,
        WideCard
    },
    mixins: [scrollToError],
    data() {
        return {
            investors: []
        };
    },
    created() {
        this.$store.dispatch("forms/showSection", "Vous et votre projet");
        this.$store.dispatch("forms/stepFocus", "Profils des investisseurs");
    },
    mounted() {
        this.investors = this.$store.getters[
            "ProfilsDesInvestisseurs/getInvestors"
        ];
    },
    methods: {
        removeInvestor(payload, index) {
            this.$store.dispatch(
                "ProfilsDesInvestisseurs/removeInvestor",
                payload
            );
            this.investors.splice(index, 1);
        },
        addInvestor() {
            if (!this.checkForms()) {
                this.investors.push({
                    model: "investor",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        motivations: [],
                        firstName: "",
                        lastName: "",
                        sex: "",
                        birthday: "",
                        SituationFamiliale: null,
                        CIN: "",
                        address: "",
                        mobilite_reduite: false,
                        email: "",
                        phone: "",
                        niveauDeFormation: null,
                        niveauDeFormationAutre: "",
                        experiencePro: null,
                        experienceProAutre: "",
                        yearsOfExperience: null,
                        formationNeed: []
                    }
                });

                this.$refs.investors[
                    this.$refs.investors.length - 1
                ].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },

        nextStep() {
            if (!this.checkForms() && this.investorsArrayLenght >= 1) {
                this.$store.dispatch("ProfilsDesInvestisseurs/SaveInvestors");
                this.$store.dispatch(
                    "forms/subStepComplete",
                    "Profils des investisseurs"
                );
                this.$router.push({
                    name: "votre_entreprise",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();
                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.investors.forEach(investor => {
                if (!investor.createInvestor()) {
                    formsHasError = true;
                }
            });

            return formsHasError;
        }
    },
    computed: {
        ...mapState("ProfilsDesInvestisseurs", {
            investorsArrayLenght: state => state.investors.length
        })
    }
};
</script>

<style></style>
